import { render, staticRenderFns } from "./EchartPie.vue?vue&type=template&id=4c7d10d9&scoped=true&"
import script from "./EchartPie.vue?vue&type=script&lang=js&"
export * from "./EchartPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d10d9",
  null
  
)

export default component.exports